"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = exports.getLocaleWeekdays = exports.getLocaleMonths = void 0;

var _react = _interopRequireWildcard(require("react"));

var _IconButton = _interopRequireDefault(require("../../IconButton"));

var _react2 = _interopRequireDefault(require("@mdi/react"));

var _js = require("@mdi/js");

var _styled = _interopRequireWildcard(require("../../../styled"));

var _utils = require("../utils");

var _CalendarGrid = require("./elements/CalendarGrid");

var _WeekRow = require("./elements/WeekRow");

var _polished = require("polished");

var _dateParts = require("../date-parts");

var _types = require("../date-parts/types");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CalendarElement = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 320px;\n  padding: 0.25rem;\n  box-shadow: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  background-color: ", ";\n  color: ", ";\n\n  > * {\n    user-select: none;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[1];
}, function (_ref2) {
  var theme = _ref2.theme;
  return (0, _polished.mix)(0.2, theme.foreground, theme.background);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.background;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.foreground;
});

var HeaderElement = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-column-gap: 0.5rem;\n  grid-template-columns: 2.5rem 1fr 2.5rem;\n  grid-template-areas: 'prev month-year next';\n  align-items: center;\n  margin: 0.25rem 0 1rem;\n"])));

var MonthYearContainerElement = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  grid-area: month-year;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));

var MonthElement = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-right: 0.25rem;\n"])));

var YearElement = _styled["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));

var NavButtonContainerElement = (0, _styled["default"])(_IconButton["default"])(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  height: 2.5rem;\n  width: 2.5rem;\n  padding: 0.5rem;\n  margin: 0;\n  opacity: ", ";\n  transition: opacity 300ms;\n  pointer-events: ", ";\n"])), function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 0.3 : 1;
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? 'none' : 'auto';
});
var PrevElement = (0, _styled["default"])(NavButtonContainerElement)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  grid-area: prev;\n"])));
var NextElement = (0, _styled["default"])(NavButtonContainerElement)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  grid-area: next;\n"])));
var NavButtonElement = (0, _styled["default"])(_react2["default"])(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral([""])));
var WeekdayNameElementElement = (0, _styled["default"])(_CalendarGrid.CalendarGridCellElement)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  text-align: center;\n"])));
/**
 * Generate month names for a given `locale` (or a fallback list of locales). Both parameters are are passed to `new Intl.DateTimeFormat`.
 * You can find [more extensive documentation][mdn-dtf] about them on MDN.
 *
 * @param [locale] A string with a BCP 47 language tag, or an array of such strings. To use the browser's default locale, omit this argument or pass undefined.
 * @param [monthFormat] month format for Intl options (defaults to `long`).
 *
 * [mdn-dtf]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 */

var getLocaleMonths = function getLocaleMonths(locale) {
  var monthFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'long';
  var intlFormatter = new Intl.DateTimeFormat(locale, {
    month: monthFormat
  });
  return Array.from({
    length: 12
  }, function (_, index) {
    return intlFormatter.format(new Date(2020, index));
  });
};
/**
 * Generate month names for a given `locale` (or a fallback list of locales). Both parameters are are passed to `new Intl.DateTimeFormat`.
 * You can find [more extensive documentation][mdn-dtf] about them on MDN.
 *
 * @param [locale] A string with a BCP 47 language tag, or an array of such strings. To use the browser's default locale, omit this argument or pass undefined.
 * @param [weekdayFormat] day format for Intl options (defaults to `long`).
 *
 * [mdn-dtf]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 */


exports.getLocaleMonths = getLocaleMonths;

var getLocaleWeekdays = function getLocaleWeekdays(locale) {
  var weekdayFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'long';
  var intlFormatter = new Intl.DateTimeFormat(locale, {
    weekday: weekdayFormat
  });
  return Array.from({
    length: 7
  }, function (_, index) {
    return intlFormatter.format(new Date(2020, 10, index + 1));
  });
};
/**
 * Creates a 2D with the days of the months correctly positioned in the grid.
 *
 * @param display - The display month object representing the month.
 * @param weekStart - The index of the day of the week to start on. Default = 0.
 */


exports.getLocaleWeekdays = getLocaleWeekdays;

var createDayArray = function createDayArray(display, weekStart) {
  var year = display[_types.DatePartEnum.YEAR] || 0;
  var month = display[_types.DatePartEnum.MONTH] || 0;
  var monthStartWeekday = new Date(year, month, 1).getDay();
  var daysInMonth = (0, _utils.getDaysInMonth)(year, month);
  var dayArray = [];

  for (var dayIndex = 0; dayIndex < daysInMonth; dayIndex += 1) {
    var gridNumber = monthStartWeekday + dayIndex - weekStart + 7;
    var gridRowNumber = Math.floor(gridNumber / 7);
    var gridColumnNumber = gridNumber % 7;
    dayArray[gridRowNumber] = dayArray[gridRowNumber] || Array(7).fill(null);
    dayArray[gridRowNumber][gridColumnNumber] = dayIndex + 1;
  }

  if (dayArray[0] == null) delete dayArray[0];
  return dayArray;
};
/**
 * Compares the optional list of DateParts used as the value prop to an equivalent optional list
 * of DateParts deeply.
 *
 * @param a - The first prop for comparison
 * @param b - The second prop for comparison
 */


var areDatePartsArrayPropsEqual = function areDatePartsArrayPropsEqual(a, b) {
  // Check types and lengths as a quick initial test
  if (a == b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  var isDifferent = false;

  for (var i = 0; i < a.length; i += 1) {
    if (!a[i].isEqualTo(b[i])) {
      isDifferent = true;
      break;
    }
  }

  return !isDifferent;
};
/**
 * Takes props value for display and converts it to a guaranteed DisplayMonthType using
 * a provided default date. If default date is not provided it uses the current date.
 *
 * @param display - The props value of display.
 * @param defaultDate - The default date to use.
 */


var defaultDisplay = function defaultDisplay(display, defaultDateParts) {
  defaultDateParts = defaultDateParts || _dateParts.DateParts.now();
  if (display == null) return defaultDateParts;

  if (typeof display === 'number') {
    return new _dateParts.DateParts(defaultDateParts[_types.DatePartEnum.YEAR], display);
  }

  return new _dateParts.DateParts(display[_types.DatePartEnum.YEAR] !== null ? display[_types.DatePartEnum.YEAR] : defaultDateParts[_types.DatePartEnum.YEAR], display[_types.DatePartEnum.MONTH] !== null ? display[_types.DatePartEnum.MONTH] : defaultDateParts[_types.DatePartEnum.MONTH]);
};

var Calendar = function Calendar(_ref7) {
  var value = _ref7.value,
      min = _ref7.min,
      max = _ref7.max,
      display = _ref7.display,
      onChange = _ref7.onChange,
      onChangeDisplay = _ref7.onChangeDisplay,
      locale = _ref7.locale,
      _ref7$weekStart = _ref7.weekStart,
      weekStart = _ref7$weekStart === void 0 ? 0 : _ref7$weekStart,
      _ref7$weekdayCharacte = _ref7.weekdayCharacters,
      weekdayCharacters = _ref7$weekdayCharacte === void 0 ? 3 : _ref7$weekdayCharacte,
      isSelectingRange = _ref7.isSelectingRange;
  var theme = (0, _styled.useTheme)();
  var currentDateParts = (0, _dateParts.useCurrentDateParts)(10000);
  var coercedValue = value != null ? value : [];

  var _useState = (0, _react.useState)(coercedValue),
      _useState2 = _slicedToArray(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultDisplay(display || coercedValue[coercedValue.length - 1], currentDateParts)),
      _useState4 = _slicedToArray(_useState3, 2),
      localDisplay = _useState4[0],
      setLocalDisplay = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      maxSelectedDate = _useState6[0],
      setMaxSelectedDate = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      minSelectedDate = _useState8[0],
      setMinSelectedDate = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      maxSelectingDate = _useState10[0],
      setMaxSelectingDate = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      minSelectingDate = _useState12[0],
      setMinSelectingDate = _useState12[1];

  if (!areDatePartsArrayPropsEqual(coercedValue, localValue)) {
    setLocalValue(coercedValue);
  }

  (0, _react.useEffect)(function () {
    var minSelected = null;
    var maxSelected = null;

    if (localValue && localValue.length) {
      var newLocalDisplay = defaultDisplay(localValue[localValue.length - 1], currentDateParts);

      if (!localDisplay.isEqualTo(newLocalDisplay)) {
        setLocalDisplay(newLocalDisplay);
      }

      localValue.forEach(function (dateParts) {
        if (minSelected === null || dateParts.isLessThan(minSelected)) {
          minSelected = dateParts;
        }

        if (maxSelected === null || dateParts.isGreaterThan(maxSelected)) {
          maxSelected = dateParts;
        }
      });
    }

    if (!(minSelectedDate && minSelectedDate.isEqualTo(minSelected))) {
      setMinSelectedDate(minSelected);
    }

    if (!(maxSelectedDate && maxSelectedDate.isEqualTo(maxSelected))) {
      setMaxSelectedDate(maxSelected);
    } // We are setting localDisplay, minSelected, maxSelected so dont want as deps
    // eslint-disable-next-line

  }, [localValue, currentDateParts]);
  (0, _react.useEffect)(function () {
    setLocalDisplay(defaultDisplay(display, currentDateParts));
  }, [display, currentDateParts]);

  var incrementMonth = function incrementMonth() {
    if (max && localDisplay[_types.DatePartEnum.YEAR] === max[_types.DatePartEnum.YEAR] && localDisplay[_types.DatePartEnum.MONTH] === max[_types.DatePartEnum.MONTH]) return;
    var localDisplayYear = localDisplay[_types.DatePartEnum.YEAR];
    var localDisplayMonth = localDisplay[_types.DatePartEnum.MONTH];
    var newDisplay = defaultDisplay(new _dateParts.DateParts(localDisplayYear != null ? localDisplayYear + (localDisplayMonth === 11 ? 1 : 0) : null, localDisplayMonth != null ? (localDisplayMonth + 1) % 12 : null), currentDateParts);
    setLocalDisplay(newDisplay);
    onChangeDisplay && onChangeDisplay(newDisplay);
  };

  var decrementMonth = function decrementMonth() {
    if (min && localDisplay[_types.DatePartEnum.YEAR] === min[_types.DatePartEnum.YEAR] && localDisplay[_types.DatePartEnum.MONTH] === min[_types.DatePartEnum.MONTH]) return;
    var localDisplayYear = localDisplay[_types.DatePartEnum.YEAR];
    var localDisplayMonth = localDisplay[_types.DatePartEnum.MONTH];
    var newDisplay = defaultDisplay(new _dateParts.DateParts(localDisplayYear != null ? localDisplayYear - (localDisplayMonth === 0 ? 1 : 0) : null, localDisplayMonth != null ? (localDisplayMonth + 11) % 12 : null), currentDateParts);
    setLocalDisplay(newDisplay);
    onChangeDisplay && onChangeDisplay(newDisplay);
  };

  var localeMonths = getLocaleMonths(locale);
  var localeWeekdays = getLocaleWeekdays(locale);
  var dayArray = createDayArray(localDisplay, weekStart);

  var onDateClick = function onDateClick(dateParts, event) {
    // Try filter out selected date
    var preFilter = _toConsumableArray(localValue);

    var postFilter = preFilter.filter(function (selected) {
      return !dateParts.isEqualTo(selected);
    }); // If its not in there add it

    if (preFilter.length === postFilter.length) {
      postFilter.push(dateParts);
    }

    onChange && onChange(postFilter, event);
    onDateLeave();
  };

  var onDateEnter = function onDateEnter(dateParts) {
    var dateIsSelected = !!(localValue && localValue.find(function (selected) {
      return dateParts.isEqualTo(selected);
    }));

    if (minSelectedDate && !dateIsSelected) {
      if (dateParts.isLessThan(minSelectedDate)) {
        setMinSelectingDate(dateParts);
        setMaxSelectingDate(maxSelectedDate);
      } else {
        setMinSelectingDate(minSelectedDate);
        setMaxSelectingDate(dateParts);
      }
    }
  };

  var onDateLeave = function onDateLeave() {
    setMinSelectingDate(null);
    setMaxSelectingDate(null);
  };

  return /*#__PURE__*/_react["default"].createElement(CalendarElement, null, /*#__PURE__*/_react["default"].createElement(HeaderElement, null, /*#__PURE__*/_react["default"].createElement(PrevElement, {
    onClick: decrementMonth,
    disabled: min && localDisplay[_types.DatePartEnum.YEAR] === min[_types.DatePartEnum.YEAR] && localDisplay[_types.DatePartEnum.MONTH] === min[_types.DatePartEnum.MONTH]
  }, /*#__PURE__*/_react["default"].createElement(NavButtonElement, {
    path: _js.mdiChevronLeft,
    size: 1,
    color: theme.foreground
  })), /*#__PURE__*/_react["default"].createElement(MonthYearContainerElement, null, /*#__PURE__*/_react["default"].createElement(MonthElement, null, localeMonths[localDisplay[_types.DatePartEnum.MONTH] || 0]), /*#__PURE__*/_react["default"].createElement(YearElement, null, localDisplay[_types.DatePartEnum.YEAR])), /*#__PURE__*/_react["default"].createElement(NextElement, {
    onClick: incrementMonth,
    disabled: max && localDisplay[_types.DatePartEnum.YEAR] === max[_types.DatePartEnum.YEAR] && localDisplay[_types.DatePartEnum.MONTH] === max[_types.DatePartEnum.MONTH]
  }, /*#__PURE__*/_react["default"].createElement(NavButtonElement, {
    path: _js.mdiChevronRight,
    size: 1,
    color: theme.foreground
  }))), /*#__PURE__*/_react["default"].createElement(_CalendarGrid.CalendarGridElement, null, /*#__PURE__*/_react["default"].createElement(_CalendarGrid.CalendarGridRowElement, null, localeWeekdays.map(function (_, index) {
    return /*#__PURE__*/_react["default"].createElement(WeekdayNameElementElement, {
      key: index
    }, localeWeekdays[(index + weekStart) % 7].slice(0, weekdayCharacters));
  })), dayArray.map(function (dates, index) {
    return /*#__PURE__*/_react["default"].createElement(_WeekRow.WeekRow, {
      dates: dates,
      min: min,
      max: max,
      display: localDisplay,
      selected: localValue,
      isSelectingRange: isSelectingRange,
      onClick: onDateClick,
      onMouseEnter: onDateEnter,
      onMouseLeave: onDateLeave,
      maxSelectedDate: maxSelectedDate,
      minSelectedDate: minSelectedDate,
      maxSelectingDate: maxSelectingDate,
      minSelectingDate: minSelectingDate,
      key: index
    });
  })));
};

exports.Calendar = Calendar;